import css from './style.module.scss';
import Footer from "../../components/footer";
import S1 from "../s1";
import S2 from "../s2";
import S3 from "../s3";
import {useState} from "react";
import {getPrizeAmount} from "../../components/wheel/logic";
import {delay} from "../../utils/delay";
import {clickAudio, failedAudio, successAudio} from "../../utils/audio";


type Step = "main" | "spin" | "result";

export default function Main () {
    const [step, setStep] = useState<Step>("main");
    const [amount, setAmount] = useState(1000000);

    function startHandler(){
        clickAudio.play();
        setStep("spin");
    }

    async function spinHandler(prize: number, spinN: number) {
        const prizeAmount = getPrizeAmount(prize);
        const newAmount = amount - prizeAmount;
        setAmount(newAmount);

        if (spinN === 3) {
            await delay(4000);
            setStep("result");

            if(newAmount > 0) {
                successAudio.play();
            }
            else{
                failedAudio.play();
            }
        }
    }

    function restartHandler(){
        setAmount(1000000);
        setStep("main");
    }

    const isMain = step === "main";

    return (
        <div className={css.wrapper}>
            <div className={css.content}>
                <S1 isShowing={step === "main"} isPrev={step === "spin"}/>
                <S2 amount={amount} onSpin={spinHandler} isShowing={step === "spin"} isPrev={step === "result"}/>
                <S3 amount={amount} onRestart={restartHandler} isShowing={step === "result"} isPrev={step === "main"}/>
            </div>
            <div className={css.footer}>
                <Footer isMain={isMain} onStart={startHandler}/>
            </div>
        </div>
    )
}
